export default {"src":"/_next/static/media/m5.ed56671d.svg","height":99,"width":104,"blurWidth":0,"blurHeight":0};